import React from 'react'
import wavePng from '../ui/waves.png'

export default function AuthLayout({ children, currentStep }) {
  return (
    <div className="min-h-screen bg-gray-50 relative">
      {/* Wave Background */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${wavePng})`,
          backgroundPosition: 'center top',
          zIndex: 0
        }}
      />

      {/* Content Container */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4">
        {/* Progress Steps if needed */}
        {currentStep && (
          <div className="mb-8">
            {/* Your progress steps component */}
          </div>
        )}

        {/* Form Content */}
        {children}
      </div>
    </div>
  )
}